import { DATABASE_NAME } from '../BaseUrl';

export const DATA_QUALITY_RULES = {
  nodeModalTitle: 'Data Quality Rules',
  firstTabName: 'Algorithm',
  secondTabName: 'Data Profiling',
  thirdTabName: 'Automatic Rules',
};

export const DATA_QUALITY_RULES2 = {
  nodeModalTitle: 'Data Quality Rules 2',
  firstTabName: 'Algorithm',
  secondTabName: 'Data Profiling',
  thirdTabName: 'Automatic Rules',
};

export const FETCH_SCHEMA = {
  nodeModalTitle: 'Fetch Schema',
  jsonMethodName: 'FetchSchema',
  database: DATABASE_NAME,
  schema: 'public',
};

export const LLM_MAPPER = {
  nodeModalTitle: 'Auto Mapper',
  jsonMethodName: 'DataMapper',
};

export const LLM_MAPPER_V2 = {
  nodeModalTitle: 'Auto Mapper V2',
  jsonMethodName: 'DataMapperV2',
};

export const READ_POSTGRES_LIST = {
  database: DATABASE_NAME,
  schema: 'public',
};

export const LLM_DQ_RULES = {
  nodeModalTitle: 'LLM DQ Rules',
  jsonMethodName: 'ApplyLLMRules',
};

export const LLM_DQ_RULES_2 = {
  nodeModalTitle: 'LLM DQ Rules 2',
  jsonMethodName: 'ApplyLLMRules2',
};

export const PE_INSIGHTS_MAPPER = {
  nodeModalTitle: 'PE Insights Mapper',
  jsonMethodName: 'PE Insights Mapper',
};

export const PE_DATA_REPORT = {
  nodeModalTitle: 'PE Data Report',
  jsonMethodName: 'PE Data Report',
};

export const READ_PDF_AZURE = {
  nodeModalTitle: 'PdfDataExtractor',
  jsonMethodName: 'FormRecognizer',
};

export const DATA_QUALITY_AGENT = {
  nodeModalTitle: 'Data Quality Agent',
  jsonMethodName: 'DQAGENT',
};

export const DEDUPLICATION_AGENT = {
  nodeModalTitle: 'Dedupe Agent',
  jsonMethodName: 'XMDM_AGENT',
  configJson: {
    xmdm_config_path: '/home/ubuntu/xmdm/sample_config.yaml',
    xmdm_out_folder: 's3://x360-qa/Kalyani-test/output',
    xmdm_use_llm: true,
    xmdm_vm_url: 'http://44.210.26.216:8080',
    xmdm_endpoint: '/run',
    payload_style: 'raw',
    timeout_sec: 60,
  },
};

export const DATA_QUALITY_REPORT = {
  nodeModalTitle: 'Data Quality Report',
  jsonMethodName: 'DataQualityReport',
};
